export default __webpack_public_path__ + "static/media/infomessage.df115667.svg";